export default {
    namespaced: true,

    actions: {
        /**
         * Make a request to reschedule given request
         *
         * @param {Object} _
         * @param {Number} order_id
         * @param {String} requested_date
         * @param {String} requested_time
         * @param {String} note
         * @param {Boolean} instantly
         * @param {Object} price
         * @return {Promise<void>}
         */
        async store (_, { order_id, requested_date, requested_time, note, instantly, price }) {
            return await axios.post(`orders/${ order_id }/reschedule-requests/`, {
                requested_time: requested_time.split('Arrival between ')[1],
                requested_date, note, instantly, price
            });
        },

        async calculate (_, { order_id, requested_date }) {
            return await axios.post(`orders/${ order_id }/calculate-price`, {
                requested_date
            });
        },

        /**
         * Accept rescheduling
         *
         * @param {Object} _
         * @param {Number} order_id
         * @param {Number} reschedule_request_id
         * @return {Promise<void>}
         */
        async approve (_, { order_id, reschedule_request_id }) {
            return await axios.patch(`orders/${ order_id }/reschedule-requests/${ reschedule_request_id }`, {
                status: 'approved',
            });
        },

        /**
         * Reject rescheduling
         *
         * @param {Object} _
         * @param {Number} order_id
         * @param {Number} reschedule_request_id
         * @return {Promise<void>}
         */
        async reject (_, { order_id, reschedule_request_id }) {
            return await axios.patch(`orders/${ order_id }/reschedule-requests/${ reschedule_request_id }`, {
                status: 'rejected',
            });
        },
    }
}
